import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import CancelButton from '../../../general/inputs/CancelButton';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { createSetupIntentSession } from '../../../../routes/doctor/billing';
import { setIsAddPaymentMethodPopupOpened, setIsLoadingPopupOpened } from '../../../../redux/features/general/navigation';
import UpdateCardElement from './UpdateCardElement';
import Popup from '../../../general/popups/items/Popup';

const stripePromise = loadStripe((process.env.REACT_APP_ENV === 'development') ? 'pk_test_51RRI3LCdPmows9pqxIwYd0BYzSGTDJgkHvNycPW2RB4jArDJbBtYznNw9gnccpY77pmPOZjTOHhJ84YwQ1tb8h6k00WkmxL9JJ' : 'pk_live_51NEjC9Cz4FNVV2I8IN6TOkkRrFMgcZngFeGmLvprkfoqJpLHH7Ncm6DVSHzXjIhkFVBQ7ExSDsLbMvVnqcmuBODu000PjXtRCf') as any; 


interface Props { 

}; 

const AddPaymentMethodPopup: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const accountInfo = useAppSelector(state => state.meta.accountInfo); 
    const [clientSecret, setClientSecret] = useState(''); 
    const [setupIntentId, setSetupIntentId] = useState(''); 

    // --

    const handlePaymentIntentSession = async () => { 

        dispatch(setIsLoadingPopupOpened(true)); 

        const res = await createSetupIntentSession() as any; 

        dispatch(setIsLoadingPopupOpened(false)); 

        if (res.data.status === 200) { 

          if (!clientSecret) { 

            setSetupIntentId(res.data.setupIntent.id); 

            setClientSecret(`${res.data.setupIntent.id}_secret_${res.data.setupIntent.client_secret}`);

          }; 

        }; 

    }; 

    // --

    // --

    useEffect(() => { 

        if (accountInfo) { 

            handlePaymentIntentSession(); 

        }; 

    },[accountInfo]); 

    // -- 

    const handleQuit = () => { 

      dispatch(setIsAddPaymentMethodPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Popup>

          {clientSecret && 
            <Elements stripe={stripePromise} options={{ clientSecret: clientSecret }}>

              <UpdateCardElement setupIntentId={setupIntentId} />

            </Elements>}

          <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

        </Popup>

  );

};

export default AddPaymentMethodPopup;